// extracted by mini-css-extract-plugin
module.exports = {"rootWrap":"ReqPassCodeEditTableCell_rootWrap__oa7GP"};